import React from "react";

import ReadinessDocumentForm from "./ReadinessDocumentForm";
import { buildReadinessQuestionsInitialValues } from "./sections/readinessQuestionsFormUtils";

export default function JobShiftReadinessDocument({ sections = {}, readiness = {}, context, onClose, onReadinessChange }) {
  return (
    <ReadinessDocumentForm
      sections={sections}
      readiness={readiness}
      context={context}
      onClose={onClose}
      onReadinessChange={onReadinessChange}
      initialValues={buildReadinessQuestionsInitialValues(readiness)}
    />
  );
}
